module.exports = __webpack_public_path__ + "static/img/V2.c1030ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/V2.png
// module id = m4U4
// module chunks = 1